export const siteInfo = {
  name: "黑料短剧档案馆",
  title: "黑料短剧",
  tagline: "一集一反转，逐帧拆解藏在镜头里的秘密",
  slogan: "黑料短剧剧情档案馆",
  intro:
    "《黑料短剧》是一部都市悬疑短剧，以一桩被重新翻出的旧事为引，把几位看似毫无交集的人重新拉回同一张网里。档案馆把它们的分集介绍、故事梗概与角色关系整理成可检索的条目，帮你在追剧时把每一个细节都对上号。",
  email: "contact@heiliaodrama.example.com",
  updateText: "每周五更新",
};

export const navLinks = [
  { id: "top", label: "首页" },
  { id: "overview", label: "剧情速览" },
  { id: "episodes", label: "热门分集" },
  { id: "characters", label: "角色图谱" },
  { id: "analysis", label: "剧情解析" },
  { id: "faq", label: "常见问题" },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20still%20of%20a%20rain-soaked%20night%20city%20alley%2C%20lone%20figure%20holding%20a%20folded%20letter%20under%20a%20flickering%20lamp%2C%20deep%20amber%20and%20crimson%20lighting%2C%20heavy%20atmosphere%2C%20moody%20suspense%20short-drama%20color%20grade%2C%20high%20detail%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=1600&height=900&seq=heiliao-hero-2026&orientation=landscape";

export const stats = [
  { value: "24", unit: "集", label: "全剧集数" },
  { value: "12", unit: "分钟", label: "单集时长" },
  { value: "6", unit: "条", label: "核心人物线" },
  { value: "每周五", unit: "", label: "固定更新" },
];

export const episodes = [
  {
    no: "第1集",
    title: "雨夜来信",
    summary:
      "一封没有署名的信件被塞进门缝，信里只有一句话和一张旧照片，尘封多年的旧事由此被重新翻出。",
    tags: ["开场悬念", "关键道具"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20drama%20still%20of%20a%20folded%20anonymous%20letter%20and%20an%20old%20photograph%20on%20a%20wooden%20table%20beside%20rain-streaked%20window%2C%20amber%20lamp%20glow%20and%20crimson%20shadow%2C%20moody%20color%20grade%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ep01&orientation=landscape",
  },
  {
    no: "第2集",
    title: "镜中裂痕",
    summary:
      "表面和睦的一对夫妻，各自在深夜拨出一通不愿被听见的电话，镜中的裂痕第一次出现在观众面前。",
    tags: ["人物关系", "双线叙事"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20still%20of%20a%20cracked%20mirror%20in%20a%20dim%20bedroom%20with%20warm%20amber%20lamp%20and%20deep%20crimson%20shadow%2C%20silhouette%20reflection%2C%20restrained%20suspense%20color%20grade%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ep02&orientation=landscape",
  },
  {
    no: "第3集",
    title: "消失的第八人",
    summary:
      "同学聚会的名单上多出一个陌生的名字，而所有当事人都坚持——那天从来只有七个人到场。",
    tags: ["群像谜题", "反转伏笔"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20still%20of%20eight%20empty%20chairs%20around%20a%20long%20dining%20table%20in%20a%20dim%20room%2C%20warm%20amber%20overhead%20light%20and%20crimson%20accent%20glow%2C%20moody%20drama%20color%20grade%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ep03&orientation=landscape",
  },
  {
    no: "第4集",
    title: "录音笔",
    summary:
      "一支被剪辑过的录音笔成为整部剧的转折点，人们开始意识到，自己记住的版本也许并不完整。",
    tags: ["关键证据", "叙事诡计"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20still%20of%20a%20small%20voice%20recorder%20on%20a%20dark%20desk%20with%20amber%20light%20beam%20and%20crimson%20edge%20glow%2C%20wire%20and%20headphones%20nearby%2C%20suspense%20color%20grade%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ep04&orientation=landscape",
  },
  {
    no: "第5集",
    title: "替身",
    summary:
      "两张几乎相同的面孔出现在同一场事故里，谁才是本尊、谁又是被安排好的替身，剧情第一次真正地翻转。",
    tags: ["身份谜题", "高潮前奏"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20still%20of%20two%20back-to-back%20silhouettes%20of%20the%20same%20figure%20in%20a%20corridor%20with%20amber%20light%20and%20crimson%20shadow%2C%20mirrored%20composition%2C%20moody%20color%20grade%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ep05&orientation=landscape",
  },
  {
    no: "第6集",
    title: "最后的筹码",
    summary:
      "散落各处的线索终于收束到同一张桌上，被称作“黑料”的东西浮出水面，而代价远比想象中沉重。",
    tags: ["线索收束", "悬念收尾"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20still%20of%20scattered%20case%20files%20and%20photographs%20spread%20across%20a%20table%20under%20a%20warm%20amber%20desk%20lamp%20with%20crimson%20accents%2C%20suspense%20color%20grade%2C%20overhead%20view%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ep06&orientation=landscape",
  },
];

export const characters = [
  {
    name: "沈砚",
    role: "调查记者",
    trait: "冷静克制",
    desc: "习惯用问题代替判断，手里的调查笔记比警方的卷宗还厚。他是最早发现信件来历不简单的人。",
    relation: "与林未是旧识，和周衍存在利益冲突。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20calm%20restrained%20male%20investigative%20journalist%20in%20a%20dark%20coat%2C%20warm%20amber%20rim%20light%20and%20crimson%20shadow%2C%20blurred%20night%20city%20background%2C%20suspense%20short-drama%20color%20grade%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=heiliao-char-shenyan&orientation=portrait",
  },
  {
    name: "林未",
    role: "身份成谜的当事人",
    trait: "沉静锐利",
    desc: "她的名字出现在每一份名单上，却始终没人能说清她的来历。沉默之下，她比谁都在意那封旧信。",
    relation: "与沈砚是旧识，被顾岚暗中保护。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20quiet%20sharp-eyed%20young%20woman%20with%20a%20calm%20expression%2C%20warm%20amber%20side%20light%20and%20deep%20crimson%20shadow%2C%20soft%20blurred%20interior%20background%2C%20moody%20suspense%20color%20grade%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=heiliao-char-linwei&orientation=portrait",
  },
  {
    name: "周衍",
    role: "行商",
    trait: "温厚藏锋",
    desc: "外人眼里的体面商人，永远笑意温和。可他记得的版本，总与别人说的对不上。",
    relation: "与沈砚存在利益冲突，是录音笔事件的当事人。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20well-dressed%20middle-aged%20male%20merchant%20with%20a%20faint%20smile%2C%20warm%20amber%20key%20light%20and%20crimson%20edge%20shadow%2C%20blurred%20warm%20interior%20background%2C%20suspense%20color%20grade%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=heiliao-char-zhouyan&orientation=portrait",
  },
  {
    name: "顾岚",
    role: "律师",
    trait: "锋利守线",
    desc: "说话像在法庭上陈述，一个字都不肯多说。她手里握着那份足以改变走向的证据。",
    relation: "暗中保护林未，是揭开“黑料”的关键人物。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20sharp%20composed%20female%20lawyer%20in%20a%20tailored%20blazer%2C%20warm%20amber%20rim%20light%20and%20crimson%20shadow%2C%20blurred%20office%20background%20at%20dusk%2C%20moody%20suspense%20color%20grade%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=heiliao-char-gulan&orientation=portrait",
  },
];

export const analysis = [
  {
    category: "伏笔梳理",
    title: "第1-3集伏笔全梳理：那封信究竟用了谁的笔迹",
    excerpt:
      "从信封上的折痕到照片背面的日期，前三集埋下的细节远比第一次观看时多。我们把出现过的四处笔迹逐一对照，还原信件真正的来源。",
    readTime: "8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20close-up%20still%20of%20handwritten%20letters%20and%20old%20photographs%20side%20by%20side%20on%20a%20dark%20desk%20under%20warm%20amber%20light%20with%20crimson%20accent%2C%20suspense%20color%20grade%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ana01&orientation=landscape",
  },
  {
    category: "人物关系",
    title: "角色关系图解构：谁在说谎，谁又在替谁掩护",
    excerpt:
      "四条人物线并非平行推进，而是围绕同一件事反复交错。我们用一张关系图把彼此的隐瞒动机摊开，看清每一次“巧合”的来路。",
    readTime: "10 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20corkboard%20covered%20with%20connected%20portrait%20photographs%20and%20red%20strings%20in%20a%20dim%20room%2C%20warm%20amber%20light%20and%20crimson%20shadow%2C%20investigation%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ana02&orientation=landscape",
  },
  {
    category: "结局解读",
    title: "结局前的五个关键反转，你漏掉了几个",
    excerpt:
      "越接近结尾，镜头语言越克制。我们按时间顺序复看最后三集，找出五个被快速带过、却直接决定结局走向的反转点。",
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20still%20of%20a%20dark%20corridor%20ending%20in%20a%20bright%20doorway%2C%20warm%20amber%20light%20spilling%20out%20with%20deep%20crimson%20shadow%2C%20dramatic%20color%20grade%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=heiliao-ana03&orientation=landscape",
  },
];

export const faqs = [
  {
    q: "黑料短剧一共有多少集？",
    a: "《黑料短剧》全剧共 24 集，单集时长约 12 分钟，适合通勤或碎片时间连续观看。档案馆会按更新节奏同步补充分集介绍。",
  },
  {
    q: "在哪里可以观看黑料短剧？",
    a: "本档案馆只做剧情整理与解析，不提供播放服务。你可以在常用的短剧平台搜索剧名观看，再回到这里对照分集介绍和角色关系。",
  },
  {
    q: "黑料短剧每周更新几集？",
    a: "剧集固定在每周五更新，具体更新集数以官方发布为准。更新后我们会第一时间补齐对应分集的故事梗概与剧情解析。",
  },
  {
    q: "黑料短剧的结局是开放式的吗？",
    a: "结局保留了部分留白，但主线谜题在最后两集已经给出明确答案。档案馆的结局解读栏目会逐条说明留白的用意与指向。",
  },
  {
    q: "新观众应该从哪里开始看？",
    a: "建议先看剧情速览了解故事梗概，再按分集顺序阅读介绍。如果只想快速入坑，可以先看角色关系图解，避免被前两集的多线叙事绕晕。",
  },
];

export const testimonials = [
  {
    name: "阿远",
    tag: "连刷两遍",
    text: "之前看第 3 集完全没注意到名单多了一个人，直到看了这里的伏笔梳理才回头重看，原来前面早就埋好了。",
  },
  {
    name: "小满",
    tag: "通勤追剧",
    text: "角色关系那部分真的救命，多线叙事本来就容易乱，看完关系图之后再看剧，每个人为什么那样做都说得通了。",
  },
  {
    name: "老陈",
    tag: "悬疑剧爱好者",
    text: "分集介绍写得克制又准确，没有剧透关键反转，但每条线索都点到了，很适合边看边对答案。",
  },
];